/* eslint-disable max-lines */
import {IFilterFacetGroup, IFilterFacetTopFilter} from 'plugins/modules/filter/types';

export const FILTERS_CATEGORY_PLACEHOLDER = {
    group: 'section',
    groupName: 'Категория',
    groupSearch: false,
    searchPlaceholder: null,
    groupExpand: true,
    groupHint: null,
    items: [
        {
            isApplied: false,
            search: false,
            code: 'section',
            customView: '0',
            hint: '',
            isCollapsed: false,
            isMultiple: false,
            maxValue: null,
            minValue: null,
            sort: 0,
            title: 'Категория',
            type: 'CHECKBOX_OR',
            unit: '',
            variants: [
                {
                    code: '',
                    count: 2616,
                    title: 'Все товары',
                },
                {
                    code: 'vino',
                    count: 2193,
                    title: 'вино',
                },
                {
                    code: 'shampanskoe_i_igristoe_vino',
                    count: 391,
                    title: 'шампанское и игристое вино',
                },
                {
                    code: 'steklo',
                    count: 19,
                    title: 'стекло',
                },
                {
                    code: 'ksn',
                    count: 9,
                    title: 'крепкие напитки',
                },
                {
                    code: 'aksessuary',
                    count: 3,
                    title: 'аксессуары',
                },
                {
                    code: 'voda_i_soki',
                    count: 1,
                    title: 'вода и соки',
                },
            ],
        },
    ],
};

//
export const FILTERS_PLACEHOLDER_CONSTANTS = [
    {
        group: 'price',
        groupName: 'Цена',
        groupSort: 9,
        groupSearch: false,
        searchPlaceholder: null,
        groupExpand: true,
        groupHint: null,
        items: [
            {
                type: 'RANGE_WITH_GROUP',
                code: 'main',
                unit: '₽',
                title: '',
                hint: '',
                isCollapsed: false,
                sort: '10',
                customView: '0',
                minRange: 324,
                maxRange: 178493,
                minValue: 0,
                maxValue: 0,
                isApplied: false,
                enum: [
                    {
                        code: 'main',
                        title: 'До 1000 ₽',
                        count: 143,
                        min: 0,
                        max: 1000,
                    },
                    {
                        code: 'main',
                        title: '1 000–3 000 ₽',
                        count: 726,
                        min: 1000,
                        max: 3000,
                    },
                    {
                        code: 'main',
                        title: '3 000–6 000 ₽',
                        count: 328,
                        min: 3000,
                        max: 6000,
                    },
                    {
                        code: 'main',
                        title: '6 000–10 000 ₽',
                        count: 119,
                        min: 6000,
                        max: 10000,
                    },
                    {
                        code: 'main',
                        title: '10 000–20 000 ₽',
                        count: 65,
                        min: 10000,
                        max: 20000,
                    },
                    {
                        code: 'main',
                        title: 'от 20 000 ₽',
                        count: 35,
                        min: 20000,
                        max: 0,
                    },
                ],
            },
            {
                type: 'ALONE_CHECKBOX',
                code: 'sale',
                unit: '',
                title: 'Товар со скидкой',
                hint: '',
                isCollapsed: true,
                sort: '11',
                customView: '0',
                isApplied: false,
                variants: [
                    {
                        count: 9,
                        title: 'Товар со скидкой',
                        isApplied: false,
                        code: 1,
                    },
                ],
                isMultiple: false,
            },
        ],
    },
    {
        group: 'none_12',
        groupName: 'none',
        groupSort: 12,
        groupSearch: false,
        searchPlaceholder: null,
        groupExpand: false,
        groupHint: null,
        items: [
            {
                type: 'ALONE_CHECKBOX',
                code: 'present_pack',
                unit: '',
                title: 'В подарочной упаковке',
                hint: '',
                isCollapsed: true,
                sort: '12',
                customView: 'gift',
                isApplied: false,
                variants: [
                    {
                        count: 14,
                        title: 'В подарочной упаковке',
                        isApplied: false,
                        code: 1,
                    },
                ],
                isMultiple: false,
            },
        ],
    },
    {
        group: 'color',
        groupName: 'Цвет',
        groupSort: 13,
        groupSearch: false,
        searchPlaceholder: null,
        groupExpand: true,
        groupHint: null,
        items: [
            {
                type: 'CHECKBOX_OR',
                code: 'color',
                unit: '',
                title: '',
                hint: '',
                isCollapsed: false,
                sort: '14',
                customView: 'chips',
                isApplied: false,
                variants: [
                    {
                        count: 70,
                        title: 'красное',
                        isApplied: false,
                        code: 'krasnoe',
                    },
                    {
                        count: 44,
                        title: 'белое',
                        isApplied: false,
                        code: 'beloe',
                    },
                    {
                        count: 1,
                        title: 'розовое',
                        isApplied: false,
                        code: 'rozovoe',
                    },
                ],
                isMultiple: true,
            },
            {
                type: 'ALONE_CHECKBOX',
                code: 'orange',
                unit: '',
                title: '',
                hint: 'Вино из белых сортов настаивается в течение нескольких дней или месяцев на кожице, косточках и гребнях винограда, благодаря чему приобретает более насыщенный золотистый цвет. Отличается высоким содержанием танинов.',
                isCollapsed: true,
                sort: '16',
                customView: 'chips',
                isApplied: false,
                variants: [
                    {
                        count: 1,
                        title: 'Оранжевое',
                        isApplied: false,
                        code: 1,
                    },
                ],
                isMultiple: false,
            },
        ],
    },
    {
        group: 'geography',
        groupName: 'География',
        groupSort: 17,
        groupSearch: true,
        searchPlaceholder: 'Страна, регион, аппелласьон',
        groupExpand: true,
        groupHint: null,
        items: [
            {
                type: 'CHECKBOX_OR',
                code: 'country',
                unit: '',
                title: 'Страна',
                hint: '',
                isCollapsed: false,
                sort: '18',
                customView: '0',
                isApplied: false,
                variants: [
                    {
                        count: 1758,
                        title: 'Франция',
                        isApplied: false,
                        code: 'frantsiya',
                    },
                    {
                        count: 694,
                        title: 'Италия',
                        isApplied: false,
                        code: 'italiya',
                    },
                    {
                        count: 129,
                        title: 'Испания',
                        isApplied: false,
                        code: 'ispaniya',
                    },
                    {
                        count: 140,
                        title: 'Россия',
                        isApplied: false,
                        code: 'rossiya',
                    },
                    {
                        count: 203,
                        title: 'Германия',
                        isApplied: false,
                        code: 'germaniya',
                    },
                    {
                        count: 71,
                        title: 'Чили',
                        isApplied: false,
                        code: 'chili',
                    },
                    {
                        count: 99,
                        title: 'Южная Африка',
                        isApplied: false,
                        code: 'yuzhnaya_afrika',
                    },
                    {
                        count: 111,
                        title: 'Австрия',
                        isApplied: false,
                        code: 'avstriya',
                    },
                    {
                        count: 28,
                        title: 'Соединенные Штаты Америки',
                        isApplied: false,
                        code: 'soedinennye_shtaty_ameriki',
                    },
                    {
                        count: 52,
                        title: 'Аргентина',
                        isApplied: false,
                        code: 'argentina',
                    },
                    {
                        count: 51,
                        title: 'Грузия',
                        isApplied: false,
                        code: 'gruziya',
                    },
                    {
                        count: 20,
                        title: 'Австралия',
                        isApplied: false,
                        code: 'avstraliya',
                    },
                    {
                        count: 5,
                        title: 'Португалия',
                        isApplied: false,
                        code: 'portugaliya',
                    },
                    {
                        count: 28,
                        title: 'Новая Зеландия',
                        isApplied: false,
                        code: 'novaya_zelandiya',
                    },
                    {
                        count: 10,
                        title: 'Армения',
                        isApplied: false,
                        code: 'armeniya',
                    },
                    {
                        count: 23,
                        title: 'Венгрия',
                        isApplied: false,
                        code: 'vengriya',
                    },
                    {
                        count: 5,
                        title: 'Греция',
                        isApplied: false,
                        code: 'gretsiya',
                    },
                    {
                        count: 10,
                        title: 'Республика Молдова',
                        isApplied: false,
                        code: 'respublika_moldova',
                    },
                    {
                        count: 8,
                        title: 'Словения',
                        isApplied: false,
                        code: 'sloveniya',
                    },
                ],
                isMultiple: true,
            },
            {
                type: 'CHECKBOX_OR',
                code: 'region',
                unit: '',
                title: 'Регион',
                hint: '',
                isCollapsed: true,
                sort: '20',
                customView: '0',
                isApplied: false,
                variants: [
                    {
                        count: 45,
                        title: 'Кастилия и Леон',
                        isApplied: false,
                        code: 'kastiliya_i_leon',
                    },
                    {
                        count: 9,
                        title: 'Риоха',
                        isApplied: false,
                        code: 'riokha',
                    },
                    {
                        count: 19,
                        title: 'Наварра',
                        isApplied: false,
                        code: 'navarra',
                    },
                    {
                        count: 5,
                        title: 'Кастилия Ла Манча',
                        isApplied: false,
                        code: 'kastiliya_la_mancha',
                    },
                    {
                        count: 32,
                        title: 'Галисия',
                        isApplied: false,
                        code: 'galisiya',
                    },
                    {
                        count: 10,
                        title: 'Каталония',
                        isApplied: false,
                        code: 'kataloniya',
                    },
                    {
                        count: 3,
                        title: 'Мадрид',
                        isApplied: false,
                        code: 'madrid',
                    },
                    {
                        count: 3,
                        title: 'Эстремадура',
                        isApplied: false,
                        code: 'estremadura',
                    },
                    {
                        count: 1,
                        title: 'Мурсия',
                        isApplied: false,
                        code: 'mursiya',
                    },
                ],
                isMultiple: true,
            },
            {
                type: 'CHECKBOX_OR',
                code: 'appellason',
                unit: '',
                title: 'Аппелласьон',
                hint: 'Аппелласьон — это территория, за которой законодательно закреплены правила, какое вино, как и из какого винограда производить.',
                isCollapsed: true,
                sort: '22',
                customView: '0',
                isApplied: false,
                variants: [
                    {
                        count: 9,
                        title: 'Rioja DOCa',
                        isApplied: false,
                        code: 'rioja_doca',
                    },
                    {
                        count: 17,
                        title: 'Navarra DO',
                        isApplied: false,
                        code: 'navarra_do',
                    },
                    {
                        count: 4,
                        title: 'Toro DO',
                        isApplied: false,
                        code: 'toro_do',
                    },
                    {
                        count: 34,
                        title: 'Rueda DO',
                        isApplied: false,
                        code: 'rueda_do',
                    },
                    {
                        count: 8,
                        title: 'Castilla y Leon VdT',
                        isApplied: false,
                        code: 'castilla_y_leon_vdt',
                    },
                    {
                        count: 1,
                        title: 'Priorat DOC',
                        isApplied: false,
                        code: 'priorat_doc',
                    },
                    {
                        count: 16,
                        title: 'Rias Baixas DO',
                        isApplied: false,
                        code: 'rias_baixas_do',
                    },
                    {
                        count: 2,
                        title: 'Valdepenas DO',
                        isApplied: false,
                        code: 'valdepenas_do',
                    },
                    {
                        count: 8,
                        title: 'Penedes DO',
                        isApplied: false,
                        code: 'penedes_do',
                    },
                    {
                        count: 3,
                        title: 'Ribera del Guadiana DO',
                        isApplied: false,
                        code: 'ribera_del_guadiana_do',
                    },
                    {
                        count: 9,
                        title: 'Valdeorras DO',
                        isApplied: false,
                        code: 'valdeorras_do',
                    },
                    {
                        count: 7,
                        title: 'Ribeiro DO',
                        isApplied: false,
                        code: 'ribeiro_do',
                    },
                    {
                        count: 2,
                        title: 'Pago de Arinzano DO',
                        isApplied: false,
                        code: 'pago_de_arinzano_do',
                    },
                    {
                        count: 2,
                        title: 'Bierzo DOP',
                        isApplied: false,
                        code: 'bierzo_dop',
                    },
                    {
                        count: 1,
                        title: 'La Mancha DO',
                        isApplied: false,
                        code: 'la_mancha_do',
                    },
                    {
                        count: 1,
                        title: 'Castilla La Mancha VdT',
                        isApplied: false,
                        code: 'castilla_la_mancha_vdt',
                    },
                    {
                        count: 1,
                        title: 'Castilla VdT',
                        isApplied: false,
                        code: 'castilla_vdt',
                    },
                    {
                        count: 1,
                        title: 'Conca de Barbera DO',
                        isApplied: false,
                        code: 'conca_de_barbera_do',
                    },
                    {
                        count: 1,
                        title: 'Yecla DO',
                        isApplied: false,
                        code: 'yecla_do',
                    },
                ],
                isMultiple: true,
            },
        ],
    },
] as unknown as IFilterFacetGroup[];

export const TOP_FILTERS_PLACEHOLDER = [
    {
        filterAlias: 'country',
        filterName: 'Страна',
        priority: '35',
    },
    {
        filterAlias: 'region',
        filterName: 'Регион',
        priority: '35',
    },
    {
        filterAlias: 'main',
        filterName: 'Цена',
        priority: '35',
    },
    {
        filterAlias: 'sugar_type',
        filterName: 'Сухое / Сладкое',
        priority: '35',
    },
    {
        filterAlias: 'grape',
        filterName: 'Сорт винограда',
        priority: '35',
    },
] as IFilterFacetTopFilter[];
